import { Controller } from '@hotwired/stimulus'
import { request } from '../lib/request'

export default class extends Controller {
  static values = {
    url: String,
    method: { type: String, default: 'post' },
    message: { type: String, default: '' },
    redirect: { type: Boolean, default: true },
    params: { type: Object, default: {} },
  }

  connect() {
    this.element.addEventListener('click', this.submit.bind(this))
  }

  async submit(event) {
    event.preventDefault()

    // Check if confirmation is needed
    if (this.messageValue && !confirm(this.messageValue)) {
      return
    }

    try {
      // Create options with params as body if available
      const options = {
        responseKind: 'json',
        contentType: 'application/json',
      }

      // Add params to the request body if they exist
      if (this.hasParamsValue && Object.keys(this.paramsValue).length > 0) {
        options.body = this.paramsValue
      }

      const response = await request(this.methodValue, this.urlValue, options)

      if (response.ok) {
        if (this.redirectValue) {
          const data = await response.json
          if (data && data.redirect_url) {
            window.location.href = data.redirect_url
          }
        }
      }
      else {
        console.error('Request failed:', response.statusCode)
      }
    }
    catch (error) {
      console.error('Error submitting form:', error)
    }
  }
}
